import { Cfg } from './config.js';

export const S = {
	lang:          Cfg.lang || 'fr',
	quoteType:     Cfg.quoteType || 'maintenance',
	// Service flow only (Phase 2) — peuplé par p2-service.js.
	service: {
		type:               '',     // diagnostic | repair | integration | calibration | training | other
		description:        '',     // texte libre initial
		conversation:       [],     // [{role:'assistant'|'user', content:'…'}]
		estimatedHours:     0,
		confidence:         '',
		summary:            '',
		analysisComplete:   false,
	},
	selModels:     {},
	sizeByRow:     {},
	otherText:     {},
	city:          '',
	placeId:       null,
	addressComponents: null,
	airport:       null,
	flightCost:    0,
	flightRoute:   '',
	emailVerified: null,
	startDate:     null,
	endDate:       null,
	robotSize:     null,
	selDate:       null,
	endDate:       null,
	// Décalage (en mois) de la 1re colonne du calendrier par rapport au mois courant.
	// Maintenance (graissage) : démarre à +2 mois — l'utilisateur planifie sa
	// prochaine visite, pas d'urgence. Service : démarre au mois courant.
	// Max: MAX_CAL_OFFSET (voir calendar.js).
	calOffset:     ( Cfg.quoteType === 'maintenance' ) ? 2 : 0,
	// Dates bloquées (techs occupés / off). Set de strings YYYY-M-D pour
	// lookup O(1). Sera peuplé par un fetch côté backend (Google Calendar
	// freebusy) ; pour l'instant on accepte aussi window.ProbotSoumUnavailable
	// pour tester visuellement.
	unavailable:   new Set(
		Array.isArray( window.ProbotSoumUnavailable ) ? window.ProbotSoumUnavailable : []
	),
	// Durée (en jours) — dérivée automatiquement des robots sélectionnés
	// via le catalogue (hours / HOURS_PER_DAY), arrondie au 0.5 supérieur.
	duration:      0,
	surcharges: {
		weekend:    false,
		urgence:    false,
		holiday:    false,
		afterhours: false,
		training:   false,
	},
};

// UTM + click ID tracking (URL → sessionStorage → cookies HubSpot)
// v1.1.53 — Étendu pour couvrir toutes les plateformes ads majeures :
//   - Google Ads (gclid)
//   - Facebook/Meta (fbclid)
//   - Microsoft/Bing Ads (msclkid)
//   - LinkedIn Ads (li_fat_id)
//   - Referrer + landing page URL (multi-touch attribution + premier point d'entrée)
export const UTM = ( function () {
	var p = new URLSearchParams( window.location.search );
	var fromUrl = {
		utm_source:    p.get( 'utm_source' )    || '',
		utm_medium:    p.get( 'utm_medium' )    || '',
		utm_campaign:  p.get( 'utm_campaign' )  || '',
		utm_content:   p.get( 'utm_content' )   || '',
		utm_term:      p.get( 'utm_term' )      || '',
		gclid:         p.get( 'gclid' )         || '',
		fbclid:        p.get( 'fbclid' )        || '',
		msclkid:       p.get( 'msclkid' )       || '',
		li_fat_id:     p.get( 'li_fat_id' )     || '',
		referrer:      ( typeof document !== 'undefined' && document.referrer ) || '',
		landing_page:  ( typeof window !== 'undefined' && window.location ) ? window.location.href : '',
		hstc:          '',
	};
	// Toute présence d'un signal d'attribution → persiste en session.
	var hasSignal = fromUrl.utm_source || fromUrl.gclid || fromUrl.fbclid || fromUrl.msclkid || fromUrl.li_fat_id;
	if ( hasSignal ) {
		try { sessionStorage.setItem( 'probot_utm', JSON.stringify( fromUrl ) ); } catch ( e ) {}
		return fromUrl;
	}
	try {
		var saved = sessionStorage.getItem( 'probot_utm' );
		if ( saved ) {
			var parsed = JSON.parse( saved );
			if ( parsed.utm_source || parsed.gclid || parsed.fbclid || parsed.msclkid || parsed.li_fat_id ) {
				// Override referrer/landing_page avec la session (vrai premier
				// point d'entrée) plutôt que le tab actuel.
				return parsed;
			}
		}
	} catch ( e ) {}
	try {
		var hstc = document.cookie.split( '; ' ).find( function ( c ) { return c.indexOf( '__hstc=' ) === 0; } );
		if ( hstc ) fromUrl.hstc = hstc.split( '=' )[ 1 ] || '';
	} catch ( e ) {}
	return fromUrl;
} )();
